.fill-1 {
  fill: #ffffff;
}
.sms-icon {
  width: 32px;
}
